import { render } from "./AwaitEmailVerificationPage.vue?vue&type=template&id=b5a435f4"
import script from "./AwaitEmailVerificationPage.vue?vue&type=script&lang=js"
export * from "./AwaitEmailVerificationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__